"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTexture = void 0;
var constants_1 = require("../const/constants");
/**
 * Build texture data from buffer
 * @param buffer The model buffer
 * @param texture Texture description
 * @returns Uint8ClampedArray with unpacked RGBA data of a texture
 */
var buildTexture = function (buffer, texture) {
    var textureArea = texture.width * texture.height;
    var isTextureMasked = texture.flags & constants_1.NF_MASKED;
    var textureData = new Uint8Array(buffer, texture.index, textureArea);
    // Palette of colors
    var palette = new Uint8Array(buffer, texture.index + textureArea, constants_1.PALETTE_SIZE);
    // RGB color which will be replaced with transparency
    var alphaColor = palette.slice(constants_1.PALETTE_ALPHA_INDEX, constants_1.PALETTE_ALPHA_INDEX + constants_1.RGB_SIZE);
    // Create new image buffer
    var imageBuffer = new Uint8ClampedArray(textureArea * constants_1.RGBA_SIZE);
    // Parsing indexed color: every item in texture data is index of color in
    // colors palette
    for (var i = 0; i < textureData.length; i++) {
        var item = textureData[i];
        var paletteOffset = item * constants_1.RGB_SIZE;
        var pixelOffset = i * constants_1.RGBA_SIZE;
        // Checks is alpha color
        var isAlphaColor = palette[paletteOffset + 0] === alphaColor[0] &&
            palette[paletteOffset + 1] === alphaColor[1] &&
            palette[paletteOffset + 2] === alphaColor[2];
        if (isTextureMasked && isAlphaColor) {
            // This modifies the model's data. Sets the mask color to black.
            // This is also done by Jed's model viewer (export texture has black)
            imageBuffer[pixelOffset + 0] = 0; // red
            imageBuffer[pixelOffset + 1] = 0; // green
            imageBuffer[pixelOffset + 2] = 0; // blue
            imageBuffer[pixelOffset + 3] = 0; // alpha
        }
        else {
            // Just applying to texture image data
            imageBuffer[pixelOffset + 0] = palette[paletteOffset + 0]; // red
            imageBuffer[pixelOffset + 1] = palette[paletteOffset + 1]; // green
            imageBuffer[pixelOffset + 2] = palette[paletteOffset + 2]; // blue
            imageBuffer[pixelOffset + 3] = 255; // alpha
        }
    }
    return imageBuffer;
};
exports.buildTexture = buildTexture;
